import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
@Injectable({
    providedIn: 'root',
})
export class LoginService {
    private tokenSubject = new BehaviorSubject<string | null>(null);
    token$ = this.tokenSubject.asObservable();

    public userData: any;
    activeUser: any;
    meObject = null;
    constructor(
        private http: HttpClient,
        private auth: AuthService
    ) {
        this.auth.getAccessTokenSilently().subscribe(token => {
            console.log('Token stored globally:', token);
            this.tokenSubject.next(token);
        });
    }
    getToken(): string | null {
        return this.tokenSubject.value;
    }
    setToken(token: string) {
        this.tokenSubject.next(token);
    }
    // ME endpoint call
    me = (): Observable<any> => {
        console.log('me');
        const meEndPoint = 'api/v1/users/me';
        return this.http.get(meEndPoint).pipe(
            map((response: any) => {
                this.activeUser = response;
                this.meObject = response;
                return response;
            }),
            catchError(error => throwError(error))
        );
    };

    // LOGIN endpoint call
    login = (userData: any): Observable<any> => {
        const loginEndpoint = 'api/v1/users/login';
        return this.http.post(loginEndpoint, userData, {}).pipe(
            map((response: any) => {
                return response;
            }),
            catchError(error => throwError(error))
        );
    };

    // LOGOUT endpoint call
    logOut = () => {
        const logOutEndpoint = 'api/v1/users/logout';

        return this.http
            .post<any>(logOutEndpoint, {
                withCredentials: true,
            })
            .pipe(
                tap(resp => {
                    return resp;
                }),
                catchError(error => {
                    return throwError(error);
                })
            );
    };
    getTaxonomyList = () => {
        const endPoint = '/api/v1/taxonomies';
        return this.http.get<any>(endPoint).pipe(
            tap(res => {
                return res;
            }),
            catchError(error => throwError(error))
        );
    };
    getVersionList = (taxonomyId: any): Observable<any> => {
        let endPoint = 'api/v1/taxonomies/versions';
        endPoint = endPoint.replace(
            'api/v1/taxonomies/versions',
            'api/v1/taxonomies/' + taxonomyId + '/versions'
        );
        return this.http
            .get<any>(endPoint)
            .pipe(catchError(error => throwError(error)));
    };

    getHierarchyList = (taxonomyId: any): Observable<any> => {
        let endPoint = 'api/v1/taxonomies/hierarchies';
        endPoint = endPoint.replace(
            'api/v1/taxonomies/hierarchies',
            'api/v1/taxonomies/' + taxonomyId + '/hierarchies'
        );
        return this.http.get(endPoint).pipe(
            map((response: any) => {
                return response;
            })
        );
    };
}
